module.exports = __webpack_public_path__ + "img/logo-dark.cc8ff9e3.svg";